export default __webpack_public_path__ + "static/businessSuccessBg-271525a09dd0d78b222a10c590feac08.png";